import { type AxiosError } from 'axios'
import { useMutation, type UseMutationOptions } from 'react-query'

import agent from 'agent'
import useAuth from 'hooks/use-auth'
import { externalIntegrationsMutationKeys } from 'queries/external-integrations/query-keys'
import {
  type AuthenticationRequestBody,
  type UpdateAuthenticationRequestParams
} from 'queries/external-integrations/types'
import { getEndpointWithParams } from 'queries/queries-utils'
import { type TeamExternalIntegrationResponse } from 'types/api/status-checks/status-check'

function updateStatusCheckAuthentication([endpoint, endpointParams]: ReturnType<
  typeof externalIntegrationsMutationKeys.updateStatusCheckAuthentication
>) {
  return async function (
    args: [UpdateAuthenticationRequestParams, AuthenticationRequestBody]
  ) {
    const [requestParams, requestBody] = args
    const endpointWithParams = getEndpointWithParams(endpoint, {
      ...endpointParams,
      ...requestParams
    })
    const response = await agent.put<TeamExternalIntegrationResponse>(
      endpointWithParams,
      requestBody
    )

    return response.data
  }
}

export function useUpdateStatusCheckAuthentication(
  options?: UseMutationOptions<
    TeamExternalIntegrationResponse,
    AxiosError,
    [UpdateAuthenticationRequestParams, AuthenticationRequestBody]
  >
) {
  const { currentTeamId: teamId } = useAuth()
  const mutationKey =
    externalIntegrationsMutationKeys.updateStatusCheckAuthentication(teamId)

  return useMutation({
    ...options,
    mutationFn: updateStatusCheckAuthentication(mutationKey),
    mutationKey
  })
}
